import React, { useState } from 'react';
import { Building2, Layers, Bell, MapPin, Shield, Upload, GitPullRequest, Lock, BookOpen, Boxes, Trash2, Settings2, Users } from 'lucide-react';
import BranchManager from './BranchManager';
import RateCardEditor from './RateCardEditor';
import NotificationSettingsTab from './NotificationSettingsTab';
import BillingAddressModule from './BillingAddressModule';
import SavedAddressBook from './SavedAddressBook';
import ApprovalWorkflowsTab from './ApprovalWorkflowsTab';
import BulkImportTab from './BulkImportTab';
import MasterChangesTab from './MasterChangesTab';
import RolePermissionsTab from './RolePermissionsTab';
import ProductMaster from '../products/ProductMaster';
import DataManagementTab from './DataManagementTab';
import OthersTab from './OthersTab';
import UserManagementTab from './UserManagementTab';

const tabs = [
  { id: 'products', label: 'Products', icon: Boxes },
  { id: 'branches', label: 'Branches', icon: Building2 },
  { id: 'users', label: 'Users', icon: Users },
  { id: 'billing', label: 'Billing Addresses', icon: MapPin },
  { id: 'address-book', label: 'Address Book', icon: BookOpen },
  { id: 'master-changes', label: 'Change Requests', icon: GitPullRequest },
  { id: 'role-permissions', label: 'Role Permissions', icon: Lock },
  { id: 'rate-card', label: 'Signage Rate Card', icon: Layers },
  { id: 'notifications', label: 'Notifications', icon: Bell },
  { id: 'approvals', label: 'Approval Workflows', icon: Shield },
  { id: 'import', label: 'Bulk Import', icon: Upload },
  { id: 'others', label: 'Others', icon: Settings2 },
  { id: 'data-mgmt', label: 'Data Management', icon: Trash2 },
];

const SettingsPage = () => {
  const [activeTab, setActiveTab] = useState('products');

  return (
    <div className="p-5 lg:p-6">
      <div className="mb-5">
        <h1 className="text-xl font-bold text-gray-900" style={{ fontFamily: 'DM Sans' }}>Settings</h1>
        <p className="text-xs text-gray-500 mt-0.5">Products, branches, rate cards & system configuration</p>
      </div>

      <div className="flex gap-1 mb-5 bg-gray-100 p-1 rounded-xl w-fit overflow-x-auto">
        {tabs.map(t => (
          <button key={t.id} onClick={() => setActiveTab(t.id)}
            className={`flex items-center gap-1.5 px-4 py-2 text-[11px] font-semibold rounded-lg transition-all ${
              activeTab === t.id ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-700'
            }`}>
            <t.icon className="w-3.5 h-3.5" />{t.label}
          </button>
        ))}
      </div>

      {activeTab === 'products' && <ProductMaster />}
      {activeTab === 'branches' && <BranchManager />}
      {activeTab === 'users' && <UserManagementTab />}
      {activeTab === 'billing' && <BillingAddressModule />}
      {activeTab === 'address-book' && <SavedAddressBook />}
      {activeTab === 'master-changes' && <MasterChangesTab />}
      {activeTab === 'role-permissions' && <RolePermissionsTab />}
      {activeTab === 'rate-card' && <RateCardEditor />}
      {activeTab === 'notifications' && <NotificationSettingsTab />}
      {activeTab === 'approvals' && <ApprovalWorkflowsTab />}
      {activeTab === 'import' && <BulkImportTab />}
      {activeTab === 'others' && <OthersTab />}
      {activeTab === 'data-mgmt' && <DataManagementTab />}
    </div>
  );
};

export default SettingsPage;
